<template>
  <div class=" is-fullwidth">
    
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in makeuplocations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
      
    </div>
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
          <th width="60">&nbsp;</th>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Design</th>
          <th>Qty</th>
          <th>CAD ID</th>
         
          <th>&nbsp;</th>
          
        </tr>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="8" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="8" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
           <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{order.cad_id}}</td>
         

            <td>
              <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id!=2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>
              </td>
          
             
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: '',
      accessToken: '',
      start_date: '',
     
    }
  },
   methods: {
    getStartDate() {
              
              var d = new Date();
              
              d.setDate(d.getDate() -30);
              return d.toISOString().slice(0,10);
              
      },
      async getOrders() {
        this.orders = []
        this.loading=true

        if(this.$route.meta.location == "offshore")
      {
        OrderService.getOffshoreMultiplyCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, '') // Took out start_date
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
      }
      else {
          OrderService.getMultiplyCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
      }

        
      },
    
    
    exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Cutting Gerber.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
        const allowedGarmentIds = [2418, 2126, 2127, 2116]
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.multiply_cutting == 0 && !allowedGarmentIds.includes(Number(u.garment_id))) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations(1);
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }

    if (localStorage.multiply_printing_location_id) {
      this.selected_location_id = localStorage.multiply_printing_location_id;
    }
    else{
      this.selected_location_id = 1
    }

    if (localStorage.printing_start_date) {
      this.start_date = localStorage.printing_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }
      
  },
  watch: {
    'selected_location_id'() {
      
      localStorage.multiply_printing_location_id = this.selected_location_id
      if(this.accessToken != "")
      {
      this.getOrders();
      }
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      if(this.accessToken != "")
      {
      this.getOrders();
      }
    },
    'start_date'() {
      localStorage.printing_start_date = this.start_date
      if(this.accessToken != "")
      {
      this.getOrders();
      }
    }
  }
}


</script>

